import React from 'react'
import { Input } from 'antd'
import { ClickEventSetter, IconSelect, ClickCustomEventSetter } from '../index'

export interface IClickInputProps {
  value?: any
  onChange?: (value: any) => void
  type?: string,
  hideClick?: boolean
}

export const ClickInput: React.FC<IClickInputProps> = ({type, hideClick, ...props}) => {
  if(type == "icon") return <IconSelect {...props} />
  if(type == 'clickProps') return (<ClickEventSetter hideClick={hideClick} senceType='modal' { ...props } />)
  if(type == "clickCustomEventProps") return <ClickCustomEventSetter  { ...props } />
  return <Input {...props} />
}
